// extracted by mini-css-extract-plugin
module.exports = {"button":"NotActiveCompetition_button__T9IBq","iconContainer":"NotActiveCompetition_iconContainer__G_2pK"};